/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9mcm9udC90ZW1wbGF0ZXMtZnJvbnQvdGVtcGxhdGUtZnJvbnQtc2hhcmVkL3RlbXBsYXRlLXN1Ymdyb3VwL3RlbXBsYXRlLXN1Ymdyb3VwLmNvbXBvbmVudC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmFyL3d3dy9odG1sL015RGVzaWduVjMvaHRtbC9zcmMvYXBwL2Zyb250L3RlbXBsYXRlcy1mcm9udC90ZW1wbGF0ZS1mcm9udC1zaGFyZWQvdGVtcGxhdGUtc3ViZ3JvdXAvdGVtcGxhdGUtc3ViZ3JvdXAuY29tcG9uZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/front/templates-front/template-front-shared/template-subgroup/template-subgroup.component.css.shim.ngstyle.ts